import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation AiSettingsMutation($enableAi: Boolean!) {
    setAiSettings(enableAi: $enableAi) {
      ok
    }
  }
`;

export const setAiSettings = (environment, enableAi, callback) => {
  const variables = {
    enableAi
  };
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};
